module.exports = __webpack_public_path__ + "img/reward.3badd922.svg";